import PropTypes from 'prop-types';

import Box from 'shopper/components/Box';

import GamificationExperience from './GamificationExperience';
import Stats from './Stats';
import UserMainInfos from './UserMainInfos';

const MainInfos = ({ gaEventCategory, user, ...rest }) => (
  <Box
    className='bg-primary-300 bg-[url("/dist/images/features/user-profile/main-info-bg.svg")] bg-cover bg-center px-4 py-10 dark:bg-primary-300 md:bg-[url("/dist/images/features/user-profile/main-info-bg@2x.svg")]'
    full
    {...rest}
  >
    <div className="flex flex-col items-center justify-between md:flex-row md:px-18">
      <UserMainInfos gaEventCategory={gaEventCategory} {...user} />
      <GamificationExperience {...user} />
    </div>
    <Stats gaEventCategory={gaEventCategory} {...user} />
  </Box>
);

MainInfos.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
  user: PropTypes.shape({}).isRequired,
};

export default MainInfos;
